import React, { useState, useEffect } from 'react';
import { WifiOff, Wifi } from 'lucide-react';

export function OfflineIndicator() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowReconnected(true);
      
      // Hide the "reconnected" message after 3 seconds
      setTimeout(() => {
        setShowReconnected(false);
      }, 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowReconnected(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Don't show anything if online (unless just reconnected)
  if (isOnline && !showReconnected) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[100]">
      {!isOnline ? (
        // Offline Banner
        <div className="bg-red-500 text-white py-2 px-4 flex items-center justify-center gap-2 shadow-lg">
          <WifiOff className="w-5 h-5" />
          <span className="font-medium text-sm">
            No internet connection - Running in offline mode
          </span>
        </div>
      ) : (
        // Reconnected Banner
        <div className="bg-emerald-500 text-white py-2 px-4 flex items-center justify-center gap-2 shadow-lg animate-slide-down">
          <Wifi className="w-5 h-5" />
          <span className="font-medium text-sm">
            Back online! ✅
          </span>
        </div>
      )}
    </div>
  );
}

// Add animation styles
const styles = `
  @keyframes slide-down-offline {
    from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0);
    }
  }

  .animate-slide-down {
    animation: slide-down-offline 0.3s ease-out;
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const existingStyle = document.getElementById('offline-indicator-styles');
  if (!existingStyle) {
    const styleSheet = document.createElement('style');
    styleSheet.id = 'offline-indicator-styles';
    styleSheet.textContent = styles;
    document.head.appendChild(styleSheet);
  }
}
